import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { usePageMeta } from "../seo";
import "../style/blog.css";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  usePageMeta({
    title: "Blog",
    description:
      "Write-ups on Windows internals, malware analysis and offensive security " +
      "techniques — process injection, syscall hooking, DLL abuse and more.",
    path: "/blog",
  });

  useEffect(() => {
    setIsLoading(true);
    fetch("/blog/meta.json", { priority: "high" })
      .then(res => res.json())
      .then(data => {
        setPosts(data);
        setIsLoading(false);
      })
      .catch(err => {
        console.error("Failed to load posts", err);
        setIsLoading(false);
      });
  }, []);

  // Filter posts based on visibility + search input
  const filteredPosts = posts.filter(post => {
    // FIRST: hide posts where visible is false
    if (!post.visible) return false;

    const term = search.toLowerCase().replace("#", "");

    const inTitle = post.title.toLowerCase().includes(term);
    const inDescription = post.description.toLowerCase().includes(term);
    const inTags = post.tags.some(tag =>
      tag.toLowerCase().includes(term)
    );

    return inTitle || inDescription || inTags;
  });

  if (isLoading) {
    return (
      <section id="blog" className="section" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "40vh" }}>
        <div className="pixel-loader"></div>
        <p style={{ marginTop: "20px", color: "var(--accent)" }}>Loading posts...</p>
      </section>
    );
  }

  return (
    <section id="blog" className="section">
      <h3><i className="fas fa-blog"></i> Latest Blog Posts</h3>

      <input
        className="pixel-input"
        type="text"
        placeholder="Search by #tag or description..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{ padding: "8px", marginBottom: "20px", width: "100%" }}
      />

      {filteredPosts.map(post => (
        // A real <a href> so crawlers can follow it; react-router still handles
        // the click as an in-app navigation. A <button> here would be invalid
        // nested inside an anchor, so the call to action is a styled <span>.
        <Link className="blog-post" key={post.id} to={`/blog/${post.url}`}>
          <h4 className="blog-post-link" style={{ color: "var(--accent)" }}>
            {post.title}
          </h4>

          <div className="blog-meta">
            <b><span>{post.date}</span></b>
          </div>

          <p style={{ color: "var(--accent)", fontSize: "14px", opacity: 0.8 }}>
            {post.tags.map(tag => `#${tag}`).join(" ")}
          </p>

          <p>{post.description}</p>

          <span className="pixel-button">
            Read Full Post →
          </span>
        </Link>
      ))}

      {filteredPosts.length === 0 && search && (
        <p style={{ textAlign: "center", color: "var(--accent)" }}>No posts found for "{search}"</p>
      )}
    </section>
  );
}